import { AutomationSourcesPage } from 'features/automation-sources';

export const TechOperatorAutomationSourcesPage = () => (
  <AutomationSourcesPage />
);
